import cn from 'classnames';
import type React from 'react';
import { CoachAvatar } from '@features/coaches/coachCard/coachAvatar/ui.tsx';
import { getInitial } from '@shared/helpers';
import type { RecommendationT } from '@shared/types/programs';
import { Card } from '@shared/ui';
import * as st from './styles.module.scss';

interface Props {
  isActive: boolean;
  onClick: () => void;
  recommendation: RecommendationT;
}

export const Recommendation: React.FC<Props> = ({ isActive, onClick, recommendation }) => {
  const coach = recommendation.coach;
  return (
    <Card
      className={cn(st.recommendation, isActive && st.active)}
      onClick={() => {
        onClick();
        // const player = document.getElementById('video');
        // player?.scrollIntoView({ behavior: 'smooth' });
      }}
    >
      <div className={st.recommendation__letter}>
        <CoachAvatar photo={coach?.photo} className={st.coachAvatar} />
      </div>
      <div className={st.recommendation__specialist}>
        <span className={st.recommendation__title}>Комментарий специалиста</span>
        <span className={st.recommendation__name}>
          {getInitial(coach?.first_name || '', coach?.last_name || '', coach?.middle_name)}
        </span>
      </div>
    </Card>
  );
};
